
import { MHTTPCL, JSON_STRING, HttpClient, createHttpGetOptions, jsonToFormData } from "../../../services/http/http-client";
import { CONTACTS_URL, LABEL_URL } from "../../../services/common-urls";

export const licenceService = {

  //old


  //new
  licenceList:(row_start=0,row_count=100,)=>MHTTPCL.post(LABEL_URL,{
    section:	"licences",
    action:	"licence_list",
    row_start:row_start,
    row_count:row_count,
    output:JSON_STRING
  }),
  licenceListSearch:(row_start=undefined,row_count=undefined,active=undefined,search=undefined)=>MHTTPCL.post(LABEL_URL,{
    section:	"licences",
    action:	"licence_list",
    row_start:row_start,
    row_count:row_count,
    active:active,
    search:search,
    output:JSON_STRING
  }),

  licenceListAdvanceSearch:(
      row_start=undefined,
      row_count=undefined,
      licence_name=undefined,
      licence_account=undefined,
      repertoire=undefined,
      licensor=undefined,
      licence_account_status_id=undefined,
      licence_status_id=undefined,
      royalty_account_id=undefined,
      licence_start1=undefined,
      licence_end1=undefined,
      licence_start2=undefined,
      licence_end2=undefined,
      last_statement_start=undefined,
      last_statement_end=undefined,
      territory_id=undefined,
    )=>MHTTPCL.post(LABEL_URL,{
    section:	"licences",
    action:	"licence_list",
    row_start:row_start,
    row_count:row_count,
    licence_name:licence_name,
    licence_account:licence_account,
    repertoire:repertoire,
    licensor:licensor,
    licence_account_status_id:licence_account_status_id,
    licence_status_id:licence_status_id,
    royalty_account_id:royalty_account_id,
    licence_start1:licence_start1,
    licence_end1:licence_end1,
    licence_start2:licence_start2,
    licence_end2:licence_end2,
    last_statement_start:last_statement_start,
    last_statement_end:last_statement_end,
    territory_id:territory_id,

    output:JSON_STRING
  }),

  licenceAdvancedSearchModalData:()=>MHTTPCL.get(LABEL_URL,{
    section:	"licences",
    action:	"licence_advanced_search_modal_data",
    output:JSON_STRING
  }),

  // autofillFromProducts:(licence_id)=>MHTTPCL.post(LABEL_URL,{
  //   section:	"licences",
  //   action:	"autofill_from_products",
  //   licence_id:licence_id,
  //   output:JSON_STRING
  // }),

  // autofillFromReleases:(licence_id)=>MHTTPCL.post(LABEL_URL,{
  //   section:	"licences",
  //   action:	"autofill_from_releases",
  //   licence_id:licence_id,
  //   output:JSON_STRING
  // }),

  autofillRelatedAsset:(licence_id,action)=>MHTTPCL.post(LABEL_URL,{
    section:	"licences",
    action:	action,
    licence_id:licence_id,
    output:JSON_STRING
  }),

  searchUnrelatedAssets:(asset_type,row_start=undefined,row_count=undefined,search=undefined )=>MHTTPCL.post(LABEL_URL,{
    section:	"licences",
    action:	"search_unrelated_assets",
    asset_type:asset_type,
    row_start:row_start,
    row_count:row_count,
    search:search,
    output:JSON_STRING
  }),

  addLicenceAsset:({licence_id , external_id,external_table})=>MHTTPCL.post(LABEL_URL,{
    section:	"licences",
    action:	"add_licence_asset",
    licence_id:licence_id,
    external_id:external_id,
    external_table:external_table,
    output:JSON_STRING
  }),


  //income new
  addLicenceLineModal1Data:(licence_id)=>MHTTPCL.get(LABEL_URL,{
    section:'licences',
    action:'add_licence_line_modal_1_data',
    licence_id:licence_id,
    output:JSON_STRING
  }),

  addLicenceLineModal2Data:(licence_track_id)=>MHTTPCL.get(LABEL_URL,{
    section:'licences',
    action:'add_licence_line_modal_2_data',
    licence_track_id:licence_track_id,
    output:JSON_STRING
  }),

  createInvoiceFromLicenceAccount:(licence_id,invoice_project_id)=>MHTTPCL.post(LABEL_URL,{
    section:'licences',
    action:'create_invoice_from_licence',
    licence_id:licence_id,
    invoice_project_id:invoice_project_id,
    output:JSON_STRING
  }),


 



  //https://dev.berlin3.com/updatecheck2/label.pl?section=licences&action=add_licence_asset&licence_id=23&external_id=1&external_table=


  // advanceSearch:({ licence_name,licence_account,licence_type,licensor_name,artist,title,date_start,date_end,last_stmt })=>MHTTPCL.post(LABEL_URL,{
  //   licence_name:licence_name,
  //   licence_account:licence_account,
  //   licence_type:licence_type,
  //   licensor_name:licensor_name,
  //   artist:artist,
  //   title:title,
  //   date_start:date_start,
  //   date_end:date_end,
  //   last_stmt:last_stmt,
  //   section	:"licences",
  //   action:	"advance_search"
  // }),
  
  selectLcncAccForm:()=>MHTTPCL.get(LABEL_URL,{
    section:"licences",
    action:"select_lcnc_acc_form"
  }),
  
  createLcncForm:(licence_account_id)=>MHTTPCL.get(LABEL_URL,{
    section:"licences",
    action:"create_lcnc_form",
    licence_account_id:licence_account_id
  
  }),




  searchSelectLcncAccs:(search)=>MHTTPCL.post(LABEL_URL,{
    section:"licences",
    action:	"search_select_lcnc_accs",
    search:search,	
    tableID:"select_lcnc_acc_Table"
  }),

  addLicence:( {licence_account_id,licence_name,licence_usage,licence_type,exclusivity,territory_id,date_start,term_years,term_month,accounting_period,due_days,currency_id,active_flag } )=>MHTTPCL.post(LABEL_URL,{
    section	: "licences",
    action	:"add_licence",
    licence_account_id:licence_account_id,
    licence_name:licence_name,
    licence_usage:licence_usage,
    licence_type:licence_type,
    exclusivity:exclusivity,
    territory_id:territory_id,
    date_start:date_start,
    term_years:term_years,
    term_month:term_month,
    accounting_period:accounting_period,
    due_days:due_days,
    currency_id:currency_id,
    active_flag:active_flag,
    royalty_info:	"Advance:&#10;Royalty+Rate:+xx%+of+XXX&#10;Rata:+1/xx&#10;Deductions:+&#10;Return+Reserve:+&#10;&#10;Digital+Bundle:+xx%&#10;Digital+Track:+xx%",
    internal_notes:	"[++]+Check+outstanding+Invoices+and+Statements&#10;[++]+HOA&#10;[++]+Contract&#10;[++]+Signed&#10;[++]+Advance&#10;[++]+Taxes"

  }),

  



  
  // advanceSearchFormData:()=>MHTTPCL.post(LABEL_URL,{
  //   section:"licences",
  //   action:"advance_search_form_data"
  // }),

  licenceDetails:(licence_id)=>MHTTPCL.get(LABEL_URL,{
    section:"licences",
    action:"licence_details",
    licence_id:licence_id
  }),

  lcncDetailsTabOverview:(licence_id)=>MHTTPCL.get(LABEL_URL,{
    section:"licences",
    action:"lcnc_details_tab_overview",
    licence_id:licence_id
  }),

  lcncAccForBatchRemainder:({year,accounting_period,email,period})=>MHTTPCL.post(LABEL_URL,{
    section:"licences",
    action:	"lcnc_acc_for_batch_remainder",
    year:	year,
    accounting_period:	accounting_period,
    email:	email,
    period:	period
  }),

  exportLicences:(licence_ids)=>HttpClient.postJSONasFormData(LABEL_URL,{
    section:'licences',
    action:'export_licences',
    licence_ids:JSON.stringify(licence_ids)

  },createHttpGetOptions({responseType: 'blob'})),

  exportLicenceLinesModal:()=>MHTTPCL.get(LABEL_URL,{
    section:"licences",
    action:"export_licence_lines_modal"
  }),

  exportLicenceLines:({invoice_date_start,invoice_date_end,payment_date_start,payment_date_end,line_date_start,line_date_end,year})=>HttpClient.postJSONasFormData(LABEL_URL,{
    section:'licences',
    action:'export_licence_lines',
    invoice_date_start:invoice_date_start,
    invoice_date_end:invoice_date_end,
    payment_date_start:payment_date_start,
    payment_date_end:payment_date_end,
    line_date_start:line_date_start,
    line_date_end:line_date_end,
    year:year
  },createHttpGetOptions({responseType: 'blob'})),



  licenceExportLicences:({
    licence_name='',
    licence_account='',
    repertoire='',
    licensor='',
    licence_account_status_id='',
    licence_status_id='',
    royalty_account_id='',
    licence_start1='',
    licence_end1='',
    licence_start2='',
    licence_end2='',
    last_statement_start='',
    last_statement_end='',
    territory_id='',
  })=>HttpClient.postJSONasFormData(LABEL_URL,{
  section:	"licences",
  action:	"export_licences",
  licence_name:licence_name,
  licence_account:licence_account,
  repertoire:repertoire,
  licensor:licensor,
  licence_account_status_id:licence_account_status_id,
  licence_status_id:licence_status_id,
  royalty_account_id:royalty_account_id,
  licence_start1:licence_start1,
  licence_end1:licence_end1,
  licence_start2:licence_start2,
  licence_end2:licence_end2,
  last_statement_start:last_statement_start,
  last_statement_end:last_statement_end,
  territory_id:territory_id,
},createHttpGetOptions({responseType: 'blob'})),










//tracks

findUnrelatedTracks:(licence_id,search_key)=>MHTTPCL.post(LABEL_URL,{
  section	:"licences",
  action	:"find_unrelated_tracks",
  licence_id	:licence_id,
  search_key	:search_key,
  dofind	:"yes",
  output:JSON_STRING
}),
lcncDetailsTabTracks:(licence_id)=>MHTTPCL.get(LABEL_URL,{
  section:"licences",
  action:"lcnc_details_tab_tracks",
  licence_id:licence_id,
  output:JSON_STRING

}),

removeRelatedTrack:(licence_id,licence_track_id)=>MHTTPCL.post(LABEL_URL,{
  section:"licences",
  action:"remove_related_track",
  licence_id:licence_id,
  licence_track_id:licence_track_id
}),

unrelatedTrackForm:(licence_id)=>MHTTPCL.get(LABEL_URL,{
  section:"licences",
  action:"unrelated_track_form",
  licence_id:licence_id
}),

addRelatedTrack:(track_id,licence_id)=>MHTTPCL.get(LABEL_URL,{
  section:"licences",
  action:"add_related_track",
  track_id:track_id,
	licence_id:licence_id
	

}),

loadRelatedTrack:(licence_id)=>MHTTPCL.get(LABEL_URL,{
  section:"licences",
  action:"load_related_track",
  licence_id:licence_id
}),

loadRelatedRoyaltyAccounts:(licence_id)=>MHTTPCL.get(LABEL_URL,{
  section:"licences",
  action:"load_related_royalty_accounts",
  licence_id:licence_id
}),

labelcopyTracks:(licence_id)=>MHTTPCL.post(LABEL_URL,{
  section:"licences",
  action:"labelcopy_tracks",
  licence_id:	licence_id
  
}),


//income



lcncDetailsTabIncome:(licence_id)=>MHTTPCL.get(LABEL_URL,{
  section:"licences",
  action:"lcnc_details_tab_income",
  licence_id:licence_id
	
}),

addLicenceLineForm:(licence_id)=>MHTTPCL.get(LABEL_URL,{
  section:"licences",
  action:"add_licence_line_form",
  licence_id:licence_id
	
}),

editLicenceLineForm:(licence_id,licence_line_id)=>MHTTPCL.get(LABEL_URL,{
  section:"licences",
  action:"edit_licence_line_form",
  licence_id:licence_id,
  licence_line_id:licence_line_id
	
}),

loadLicenceLines:(licence_id)=>MHTTPCL.get(LABEL_URL,{
  section:"licences",
  action:"load_licence_lines",
  licence_id:licence_id
}),


addEditLicenceLine:({ action,
                      licence_line_date,
                      licence_line_period_txt,
                      licence_line_year,
                      currency_id,
                      text,
                      sales_info,
                      statement_amount=0,
                      reserve_amount=0,
                      invoice_amount=0,
                      balance_amount=0,
                      licence_track_id=undefined,
                      external_id=undefined,
                      external_table=undefined,
                      licence_id,
                      licence_line_id,
                      qty_info=0,
                    })=>MHTTPCL.post(LABEL_URL,{
  section:"licences",
  action:action,
  licence_line_date:licence_line_date,
  licence_line_period_txt:licence_line_period_txt,
  licence_line_year:licence_line_year,
  currency_id:currency_id,
  text:text,
  sales_info:	sales_info,
  qty_info:qty_info,
  statement_amount:statement_amount,
  reserve_amount:reserve_amount,
  balance_amount:	balance_amount,
  invoice_amount:invoice_amount,
  licence_track_id:licence_track_id,
  external_id:external_id,
  external_table:external_table,
  licence_id:licence_id,
  licence_line_id:licence_line_id
  
}),

licenceAccountReminderEmail:({licence_account_id,email,year,accounting_period,period})=>MHTTPCL.post(LABEL_URL,{
  section	: "licences",
  action	:"licence_account_reminder_email",
  licence_account_id	:licence_account_id,
  email	:email,
  year	:year,
  accounting_period:accounting_period,
  period:period
}),

removeLicenceLine:(licence_line_id)=>MHTTPCL.post(LABEL_URL,{
  section	: "licences",
  action	: "remove_licence_line",
  licence_line_id	:licence_line_id
}),

invoiceProjectsForm:(licence_id)=>MHTTPCL.get(LABEL_URL,{
  section:"licences",
  action:"invoice_projects_form",
  licence_id:licence_id
}),

licenceLinesToInvoice:({
        invoice_language ,
        vat_rate1 ,
        vat_rate2,
        vat_rate3,
        invoice_user_id,
        invoice_date,
        invoice_project_id,
        money_account_id ,
        payment_method_id,
        invoice_ref_key,
        licence_id,
        due_days,
        discount_days,
        discount_percent

      })=>MHTTPCL.post(LABEL_URL,{
  section	:"licences",
  action	:"licence_lines_to_invoice",
  invoice_language	:invoice_language,
  vat_rate1	:vat_rate1,
  vat_rate2	:vat_rate2,
  vat_rate3	:vat_rate3,
  invoice_user_id	:invoice_user_id,
  invoice_date	:invoice_date,
  invoice_project_id	:invoice_project_id,
  money_account_id	:money_account_id,
  payment_method_id	:payment_method_id,
  invoice_ref_key	:invoice_ref_key,
  licence_id	:licence_id,
  due_days	:due_days,
  discount_days	:discount_days,
  discount_percent	:discount_percent
})






















  

  



  

}
